var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FrameCacheMode, FrameCacheEvent, } from './types';
import { EventEmitter } from './util/event-emitter';
import { AlignmentConfig } from './analytics-lib/alignment';
import { Playback } from './playback';
import { log, FACILITY as LOG_FACILITY } from './util/log';
import { AnalyticsTuple } from './analytics-lib/analytics-tuple';
import { deepCopy } from './util/deepCopy';
var LOG = LOG_FACILITY.FRAME_CACHE;
var FrameCache = (function () {
    function FrameCache(parent) {
        var _this = this;
        this.initialize = function () {
            log.debug(LOG, 'initialize');
            _this.mode = FrameCacheMode.None;
            _this.parent.setMovementName('FREE PLAY');
            _this.frameIndex = 0;
            _this.frameCount = 0;
            _this.modelStates = new Map();
            _this.analyticTuples = new Map();
            _this.timingsSet = new Set();
            _this.currentFrame = null;
            _this.startTime = 0;
            _this.endTime = 0;
            _this.duration = 0;
            _this.timelineTags = [];
            _this.sessionAlignment = new AlignmentConfig();
            _this.playback.initialize();
        };
        this.captureBegin = function (movementName) {
            if (movementName === void 0) { movementName = ''; }
            log.info(LOG, 'captureBegin');
            if (movementName !== '') {
                _this.parent.setMovementName(movementName);
            }
            _this.frameIndex = 0;
            _this.frameCount = 0;
            _this.modelStates.clear();
            _this.analyticTuples.clear();
            _this.timingsSet.clear();
            _this.startTime = 0;
            _this.endTime = 0;
            _this.duration = 0;
            _this.playback.initialize();
            _this.setMode(FrameCacheMode.Capture);
        };
        this.captureComplete = function () {
            log.info(LOG, 'captureComplete');
            var timings = Array.from(_this.timingsSet);
            timings.sort();
            _this.startTime = timings[0];
            _this.endTime = timings[timings.length - 1];
            _this.duration = Math.round((Number(_this.endTime) - Number(_this.startTime)) / 1000);
            _this.setMode(FrameCacheMode.Live);
        };
        this.setMode = function (mode) {
            log.debug(LOG, _this.mode, '->', mode);
            if (mode === _this.mode) {
                return;
            }
            if (_this.mode === FrameCacheMode.Capture) {
                EventEmitter.removeListener(FrameCacheEvent.ModelUpdate, _this.onModelUpdateCapture);
            }
            if (_this.mode === FrameCacheMode.Live) {
                EventEmitter.removeListener(FrameCacheEvent.ModelUpdate, _this.onModelUpdateLive);
            }
            if (mode === FrameCacheMode.Capture) {
                EventEmitter.onSingle(FrameCacheEvent.ModelUpdate, _this.onModelUpdateCapture);
            }
            else if (mode === FrameCacheMode.Live) {
                EventEmitter.onSingle(FrameCacheEvent.ModelUpdate, _this.onModelUpdateLive);
            }
            _this.mode = mode;
        };
        this.onModelUpdateCapture = function (frame) {
            var state = deepCopy(frame.state);
            var analyticsTuple = new AnalyticsTuple(frame.analyticsTuple.timestamp, frame.analyticsTuple.tuple);
            _this.modelStates.set(frame.state.timestamp, __assign(__assign({}, state), { index: _this.frameIndex }));
            analyticsTuple.index = _this.frameIndex;
            _this.analyticTuples.set(state.timestamp, analyticsTuple);
            _this.frameIndex = _this.timingsSet.add(state.timestamp).size;
            _this.frameCount = _this.frameIndex;
            EventEmitter.emitState(state);
            EventEmitter.emitAnalytics(analyticsTuple);
        };
        this.onModelUpdateLive = function (frame) {
            var state = deepCopy(frame.state);
            var analyticsTuple = new AnalyticsTuple(frame.analyticsTuple.timestamp, frame.analyticsTuple.tuple);
            _this.analyticTuples.set(state.timestamp, analyticsTuple);
            EventEmitter.emitState(state);
            EventEmitter.emitAnalytics(analyticsTuple);
        };
        this.parent = parent;
        this.mode = FrameCacheMode.None;
        this.frameIndex = 0;
        this.modelStates = new Map();
        this.analyticTuples = new Map();
        this.timingsSet = new Set();
        this.currentFrame = null;
        this.startTime = 0;
        this.endTime = 0;
        this.duration = 0;
        this.timelineTags = [];
        this.frameCount = 0;
        this.sessionAlignment = new AlignmentConfig();
        this.playback = new Playback(this);
    }
    FrameCache.prototype.getCurrentFrame = function () {
        return this.currentFrame;
    };
    FrameCache.prototype.stateUpdate = function (stateFrame) {
        console.log('stateFrame', stateFrame);
    };
    FrameCache.prototype.isRecording = function () {
        return this.mode === FrameCacheMode.Capture;
    };
    FrameCache.prototype.isLive = function () {
        return (this.mode === FrameCacheMode.Live ||
            this.mode === FrameCacheMode.LiveCamera);
    };
    return FrameCache;
}());
export { FrameCache };
//# sourceMappingURL=frame-cache.js.map